import { useClaims } from "./use-claims";

import type { UUID } from "../../../utils/uuid";

export const useAccountId = (): UUID | undefined => {
  const claims = useClaims();
  return claims?.["http://changeengine.com/account_id"];
};
